var _ = require('lodash');


export const FIGOCset1 = _.shuffle([
    {
        combination: "Алекс + Джон",
        answer: "они"
    }, {
        combination: "Я + Джон",
        answer: "мы"
    }, {
        combination: "Алекс + ты",
        answer: "вы"
    }, {
        combination: "Алекс",
        answer: "он"
    }, {
        combination: "Лаура",
        answer: "она"
    }, {
        combination: "Компьютер (masculine)",
        answer: "он"
    }, {
        combination: "Машина (feminine)",
        answer: "она"
    }
]);